<template>
    <v-dialog width="800" v-model="visibilidadeDialogo">
        <template slot="activator">
            <div @click="mostrarCaixaDialogo">
                <span v-if="descricao.length < tamanho">{{ descricao }}</span>
                <span v-else>{{ descricao | azClipText(tamanho) }}</span>
                <span class="botao">
                    Ver Mais
                </span>
            </div>
        </template>

        <v-card v-if="caixaVisivel">
            <v-card-title class="primary modal-title" primary-title>
                <span>Itens</span>
                <v-btn flat depressed @click="fecharCaixaDialogo">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md slot="body">
                    <v-data-table v-if="itens" :headers="colunas" :items="itens" class="az-table-list tabela-item">
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td>
                                    {{ props.item.sequencia }}
                                </td>
                                <td>
                                    {{ props.item.descricao}}
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <v-layout v-else wrap white>
                        <span>{{ descricao }}</span>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'VerMais',
    $_veeValidate: {
        validator: 'new'
    },
    props: ['tamanho', 'descricao', 'itens'],
    data() {
        return {
            value: {
                required: true
            },
            caixaVisivel: false,
            visibilidadeDialogo: false,
            colunas: [
                {
                    value: 'sequencia',
                    sortable: true,
                    width: '10%',
                    text: 'Seq',
                    class: 'primary--text',
                    align: 'center'
                },
                {
                    value: 'descricao',
                    sortable: false,
                    width: '90%',
                    text: 'Descrição',
                    class: 'primary--text',
                    align: 'left'
                }
            ]
        }

    },
    methods: {
        mostrarCaixaDialogo() {
            this.caixaVisivel = true
        },
        fecharCaixaDialogo() {
            this.caixaVisivel = false
            this.visibilidadeDialogo = false
        }
    }
}
</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        .v-btn
            padding 0
            margin 0
            color #fff
            box-sizing border-box
            min-width 25px

    .botao
        text-transform none !important
        color var(--v-primary-lighten1) !important
        margin-bottom 0

    .tabela-item td:nth-of-type(1)
        text-align center

    @media (max-width 720px)
        .tabela-item
            td:nth-of-type(1)
                text-align left

            td:nth-of-type(1):before
                content "Sequência:"

            td:nth-of-type(2):before
                content "Descrição:"
</style>